<template>
    <div class="blank-space">
        <span>&nbsp;</span>
    </div>
</template>
  
<script>
/* eslint-disable */
import { mapMutations } from 'vuex'

export default {
    data(){
        return {
            uniqueId: `${this._uid}-logout`
        }
    },    
    mounted(){
        this.setLoaderText(this.$t("Common.finishing-logout"));
        this.setLoaderQueue(this.uniqueId);

        const self = this;
        this.$security.signOut().then(
            (result) => {
                self.clearLoaderQueue();
                self.setLoaderText(null);
            }
        ).catch(
            (err) => {
                self.clearLoaderQueue();
                self.setLoaderText(null);
            }
        );            
    },  
    methods:{
        ...mapMutations("app", ["setLoaderQueue", "setLoaderText", "clearLoaderQueue"]),   
    },    
}
</script>

<style lang="scss" scoped>
@import "../../styles/material-dashboard/variables";

div{
    display: block;
    height: 700px;
    color: $body-color;
}
</style>
